import { ColumnFilterItem } from "antd/es/table/interface";
import dayjs from "dayjs";

export const filterByEqual = (a: any, b: any) => a === b;

export const filterExistingFields = (
  record: { [key: string]: any }[],
  dataName: string,
  fromTo?: { [key: string]: any }[],
  isDate?: boolean
): ColumnFilterItem[] => {
  const filters: ColumnFilterItem[] = [];

  if (record) {
    for (const item of record) {
      if (filters.filter((e) => e.value === item[dataName]).length === 0) {
        let text = item[dataName];

        if (fromTo) {
          if (fromTo.length > 0) {
            const element = fromTo.find((e) => e.value === item[dataName]);

            if (element) {
              text = element.label;
            }
          }
        }

        if (typeof text != "undefined" && text !== null && text !== "") {
          if (dayjs(text).isValid() && isDate) {
            text = dayjs(text).format("DD/MM/YYYY");
          }

          filters.push({
            text,
            value: item[dataName],
          });
        }
      }
    }
  }

  return filters;
};
